<template>
  <v-card>
    <div class="px-4 py-4">
      <!-- <h6 class="text-h6 text-typo font-weight-bold">Сурагчдын тоо (ангиар)</h6> -->
      <div class="card-padding">
        <div class="chart">
          <canvas
            :id="'chart' + $attrs.iidd"
            class="chart-canvas"
          ></canvas>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
/*eslint-disable*/
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { sync } from "vuex-pathify";
const fb = require("@/firebaseConfig.js");
Chart.register(ChartDataLabels);
export default {
  components: {},
  data() {
    return {
      chartLabels: null,
      chartNumbers: null,
    };
  },
  computed: {
    ...sync("*"),
  },
  methods: {
    find() {
      setTimeout(() => {
        var xChart = document.getElementById("chart" + this.$attrs.iidd);
        if (xChart) {
          new Chart(xChart.getContext("2d"), {
            type: "bar",
            data: {
              labels: this.chartLabels,
              datasets: [
                {
                  label: "Сонгосон тоо",
                  tension: 0.4,
                  borderWidth: 0,
                  borderRadius: 4,
                  borderSkipped: false,
                  backgroundColor: "#ff5a5f",
                  data: this.chartNumbers,
                  maxBarThickness: 6,
                  datalabels: {
                    color: "#ff5a5f",
                    align: "end",
                    anchor: "end",
                  },
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false,
                },
                datalabels: {
                  color: "#36A2EB",
                },
              },
              interaction: {
                intersect: true,
                mode: "index",
              },
              scales: {
                y: {
                  grid: {
                    drawBorder: false,
                    display: false,
                    drawOnChartArea: true,
                    drawTicks: false,
                    borderDash: [5, 5],
                  },
                  ticks: {
                    display: true,
                    padding: 15,
                    color: "#9ca2b7",
                  },
                },
                x: {
                  grid: {
                    drawBorder: false,
                    display: true,
                    drawOnChartArea: true,
                    drawTicks: false,
                    borderDash: [5, 5],
                  },
                  ticks: {
                    display: true,
                    padding: 10,
                    color: "#9ca2b7",
                  },
                },
              },
            },
          });
        }
      }, 1000);
    },
  },
  mounted() {
    this.chartLabels =  [ ]
    this.chartNumbers = [ ];
    
    this.$attrs.xx.forEach(x =>  {
      this.chartLabels.push(x)
    });
    this.$attrs.yy.forEach(y =>  {
      this.chartNumbers.push(y)
    });
    this.find();
  },
};
</script>
